import { BaseModalV2 } from 'components/ui/BaseModal'
import { IPop } from 'constants/interfaces'
import React from 'react'
import { StartConversationsBlock } from '../StartConversationsBlock'
import { AIPopBody } from './AIPopBody'
import { ModalHeaderWithClose } from '../ModalHeaderWithClose'
import { useChatGptSessionCleanup } from '../hooks/useChatGptSessionCleanup'

interface IProps {
  isOpen: boolean
  handleSubmit: (popType: number | undefined) => void
  aiPop: IPop
}

export const AIPop = ({ isOpen, handleSubmit, aiPop }: IProps) => {
  const handleClose = () => {
    handleSubmit(aiPop.pop_type)
  }

  useChatGptSessionCleanup()

  return (
    <BaseModalV2
      modalContentProps={{
        borderRadius: '50px',
        width: '100%',
        maxW: '32rem',
      }}
      modalHeaderProps={{
        boxShadow: 'none',
        pb: '35px',
        position: 'relative',
      }}
      modalBodyProps={{
        backgroundColor: 'white',
        height: '100%',
        minHeight: '270px',
      }}
      isOpen={isOpen}
      onClose={handleClose}
      header={<ModalHeaderWithClose aiPop={aiPop} onClose={handleClose} />}
      body={<AIPopBody aiPop={aiPop} />}
      footer={<StartConversationsBlock pop={aiPop} handleClose={handleClose} />}
    />
  )
}
